<template>
  <div class="footerBox">
    <div class="footer-2">
      <div>
        <img src="@/assets/img/jg.png" alt="" class="gh" />
      </div>

      <div class="bq">
        <div>版权所有：中国人民政治协商会议张家口市委员会</div>
        <div>
          地址：张家口市高新区长城西大街 邮编：075000 网站访问量：{{ footerCount }}
        </div>
        <div class="flex-box" @click="goLink('http://www.beian.miit.gov.cn/')">
          冀ICP备20016785号<img src="@/assets/images/home/03.png" alt="" />
          <div @click="goLink('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13070902000290')">冀公网安备 13070902000290号</div>
        </div>
      </div>

      <div class="scan">
        <img src="@/assets/images/home/qrcode.png" alt="" class="scanImg" />
      </div>
    </div>

    <!-- <img class="footerImg" src="@/assets/img/footer.png" alt="图片"> -->
  </div>
</template>

<script>
import api from "@/utils/api.js";
export default {
  name: "FooterPage",
  props: {
    showSearch: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showWeb: false, // 是否显示下方网站列表
      showWebIndex: -1,
      footerCount: 0,
      currentMenu: {
        name: "全国人大",
        sites: ["北京人大", "天津人大", "河北人大"],
      }, // 当前鼠标悬停的菜单
      menus: [
        {
          name: "全国人大",
          sites: [
            { name: "中国人大网", url: "http://www.npc.gov.cn/npc/index.html" },
          ],
        },
        {
          name: "省级人大",
          sites: [
            { name: "北京人大", url: "https://www.bjrd.gov.cn/" },
            { name: "天津人大", url: "https://www.tjrd.gov.cn/" },
            { name: "河北人大", url: "http://www.hbrd.gov.cn/index.shtml" },
          ],
        },
        {
          name: "市级人大",
          sites: [
            { name: "合肥人大", url: "http://www.hefeirenda.cn/" },
            { name: "淮北人大", url: "https://www.ahhbrd.gov.cn/" },
            { name: "亳州人大", url: "http://www.bzrd.gov.cn/" },
          ],
        },
        {
          name: "一府一委两院",
          sites: [
            { name: "安徽省人民政府网", url: "https://www.ah.gov.cn/" },
            { name: "安徽纪检监察网", url: "http://www.ahjjjc.gov.cn/" },
            {
              name: "安徽法院网",
              url: "http://ahfy.ahcourt.gov.cn/index.shtml",
            },
          ],
        },
        {
          name: "其他网站",
          sites: [
            { name: "人民网", url: "http://www.people.com.cn/" },
            { name: "新华网", url: "http://www.xinhuanet.com/" },
            { name: "国家网信办", url: "http://www.cac.gov.cn/" },
          ],
        },
      ],
    };
  },
  created() {
    this.getFooterCount();
  },
  methods: {
    //获取访问量
    async getFooterCount() {
      const res = await api.getFooterCount(window.$configApi.webSiteId);
      this.footerCount = res.data.intCount || 0;
    },
    goLink(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.flex-box {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.footerBox {
  position: relative;
  background: linear-gradient(180deg, #EDF5FC 0%, #F8FCFF 100%);

  .footerImg {
    width: 100%;
    height: 400px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

.footer-2 {
  position: relative;
  z-index: 9;
  height: 200px;
  // background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 140px;

  .gh {
    width: 100px;
  }

  .bq {
    font-size: 14px;
    line-height: 28px;
    text-align: center;
    color: #222;
    a {
      color: #222;
      // text-decoration: underline;
    }
  }

  .scan {
    font-size: 14px;
    line-height: 28px;
    text-align: center;
    color: #222;

    .scanImg {
      width: 114px;
    }
  }
}
</style>
